import { useSearchParams } from "react-router-dom";

import { CurrencyToType } from "@/generated/api/users";
import { currencyEnum } from "@/routes/shared/currency.params";

const currencies = Object.keys(CurrencyToType).filter((currency) =>
  ["CZK", "EUR", "RON"].includes(currency),
);

const useCurrency = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currencyParam = currencyEnum.parse(searchParams.get("currency"));

  const setCurrency = (next: CurrencyToType) => {
    setSearchParams((cur) => {
      cur.set("currency", next);
      return cur;
    });
  };

  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    setCurrency(e.target.value as CurrencyToType);
  };

  const Component = (
    <select
      className="-mr-2 rounded-2xl border-0 bg-transparent hover:bg-can-silver-gray"
      defaultValue={currencyParam}
      onChange={handleChange}
    >
      {currencies.map((currency) => (
        <option key={currency} value={currency}>
          {currency}
        </option>
      ))}
    </select>
  );

  return [Component, currencyParam as CurrencyToType, setCurrency] as const;
};

export { currencies, useCurrency };
export type { CurrencyToType as Currency };
